import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import assets from './assets'
import locations from './locations'
import meta from './meta'
import quote from './quote'
import time from './time'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    assets,
    locations,
    meta,
    quote,
    time,
    user,
  },
  strict: false,
})
